class Localization {
  constructor() {
    this.Back = ''
    this.Play = ''
    this.Autoplay = ''
    this.Pause = ''
    this.Next = ''
    this.Replay = ''
    this.VolumeText = ''
    this.Volume = ''
    this.Mute = ''
    this.UnMute = ''
    this.Live = ''
    this.Previous = ''
    this.Settings = ''
    this.Minimize = ''
    this.FullScreen = ''
    this.Chromecast = ''
    this.Airplay = ''
    this.Quality = ''
    this.Subtitles = ''
    this.Theater = ''
    this.Skip = ''
    this.SkipIn = ''
    this.Visit = ''
    this.Info = ''
    this.PictureInPicture = ''
    this.SkipIntro = ''
    this.ContinueWatching = ''
    this.Playlist = ''
    this.PlaybackSpeed = ''
    this.ContinueAfterPause = ''
    this.NextVideoCancel = ''
    this.PlayNow = ''
    this.PlaybackRate = ''
    this.Auto = ''
    this.CopyLink = ''
    this.Copy = ''
    this.Off = ''
    this.On = ''
    this.Normal = ''
    this.Share = ''
    this.Close = ''
    this.SimultaneousAds = ''
    this.ZoomIn = ''
    this.ZoomOut = ''
    this.OriginalZoom = ''
    this.ApiErrorOverlay = null
    this.SourceErrorOverlay = null
    this.PlayerErrorOverlay = null
    this.CaptionsOff = null
    this.ChromeCastPlayingOn = null
    this.Dismiss = null
    this.AdAnnouncement = ''
    this.UpNext = ''
    this.GeoBlockedTitle = ''
    this.GeoBlockedDescription = ''
    this.StreamInterruptedTitle = ''
    this.StreamInterruptedDescription = ''
    this.PlaybackErrorTitle = ''
    this.PlaybackErrorDescription = ''
    this.StreamStartingTitle = ''
    this.StreamStartingDescription = ''
    this.UnpublishedTitle = ''
    this.UnpublishedDescription = ''
    this.PrivateTitle = ''
    this.PrivateDescription = ''
    this.AutoGeneratedSubtitles = ''
    this.PaywallRestrictedHover = ''
    this.Refresh = ''
    this.audioOnly = ''
    this.videoMode = ''
    this.rewind = ''
    this.forward = ''
    this.PaywallRestrictedTitle = ''
    this.PaywallRestrictedDescription = ''
    this.PaywallRestrictedButton = ''
    this.VolumteText = ''
    this.PlaylistText = ''
  }
}

export default Localization
